import React from 'react';

/**
 * AuthLayout
 *
 * Split-screen layout for login and signup pages.
 * Left panel: Brand marketing content.
 * Right panel: {children} — the auth form.
 *
 * Responsive: stacks vertically on mobile, side-by-side on md+.
 */
function AuthLayout({ children }) {
  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* ── Left panel: brand / marketing ── */}
      <div
        className="flex flex-col justify-center px-10 py-16 md:w-1/2 order-2 md:order-1"
        style={{
          backgroundColor: '#111',
          borderRight: '1px solid rgba(33,138,255,0.25)',
        }}
      >
        {/* Brand name */}
        <div className="mb-8">
          <h1 className="text-4xl font-extrabold tracking-tight leading-none" style={{ color: '#218aff' }}>
            OptionsLeveling
          </h1>
          <p className="mt-3 text-xl font-medium text-white/80">
            Options Analytics for Smarter Trades
          </p>
        </div>

        {/* Value propositions */}
        <ul className="space-y-6 text-left">
          <li className="flex items-start gap-4">
            <span
              className="mt-1 flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center"
              style={{ backgroundColor: 'rgba(33,138,255,0.15)', border: '1px solid rgba(33,138,255,0.4)' }}
            >
              <svg className="w-3.5 h-3.5" style={{ color: '#218aff' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <p className="text-white/75 text-base leading-relaxed">
              Compare potential returns between stocks and options. Simulate scenarios. Make informed decisions.
            </p>
          </li>
          <li className="flex items-start gap-4">
            <span
              className="mt-1 flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center"
              style={{ backgroundColor: 'rgba(33,138,255,0.15)', border: '1px solid rgba(33,138,255,0.4)' }}
            >
              <svg className="w-3.5 h-3.5" style={{ color: '#218aff' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <p className="text-white/75 text-base leading-relaxed">
              Stop guessing whether buying the stock or option is better — see exactly how investments perform under different conditions.
            </p>
          </li>
          <li className="flex items-start gap-4">
            <span
              className="mt-1 flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center"
              style={{ backgroundColor: 'rgba(33,138,255,0.15)', border: '1px solid rgba(33,138,255,0.4)' }}
            >
              <svg className="w-3.5 h-3.5" style={{ color: '#218aff' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <p className="text-white/75 text-base leading-relaxed">
              Track positions and know when to exit.
            </p>
          </li>
        </ul>
      </div>

      {/* ── Right panel: auth form ── */}
      <div className="flex items-center justify-center px-6 py-12 md:w-1/2 bg-background order-1 md:order-2">
        {children}
      </div>
    </div>
  );
}

export default AuthLayout;
